import React, { useEffect, useState, createContext, useContext } from 'react';
interface PricingContextType {
  price: string;
  priceValue: number;
  currency: string;
  currencySymbol: string;
  isEurope: boolean;
  isLoading: boolean;
}
const PricingContext = createContext<PricingContextType>({
  price: '€299',
  priceValue: 299,
  currency: 'EUR',
  currencySymbol: '€',
  isEurope: true,
  isLoading: true
});
// European countries + Ukraine (ISO codes)
const EUROPEAN_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'UA', 'GB', 'CH', 'NO', 'IS', 'LI', 'AL', 'AD', 'AM', 'AZ', 'BY', 'BA', 'GE', 'MD', 'MC', 'ME', 'MK', 'RS', 'SM', 'TR', 'VA', 'RU' // Russia - also show EUR
];
export function PricingProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isEurope, setIsEurope] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    async function detectRegion() {
      try {
        // Use free IP geolocation API
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        if (data.country_code) {
          const isEuropeanCountry = EUROPEAN_COUNTRIES.includes(data.country_code);
          setIsEurope(isEuropeanCountry);
        }
      } catch (error) {
        // Default to Europe pricing if detection fails
        console.log('Region detection failed, defaulting to EUR');
        setIsEurope(true);
      } finally {
        setIsLoading(false);
      }
    }
    detectRegion();
  }, []);
  const value: PricingContextType = {
    price: isEurope ? '€299' : '$350',
    priceValue: isEurope ? 299 : 350,
    currency: isEurope ? 'EUR' : 'USD',
    currencySymbol: isEurope ? '€' : '$',
    isEurope,
    isLoading
  };
  return <PricingContext.Provider value={value} data-id="element-342">{children}</PricingContext.Provider>;
}
export function usePricing() {
  return useContext(PricingContext);
}